module.exports = __webpack_public_path__ + "static/hoodie.af81baa9.png";